import { AlertTriangle, HelpCircle } from 'lucide-react'
import { cn } from '@/lib/utils'
import type { PrecisionExplanation } from '../lib/precision-explainer'

interface Props {
  explanation: PrecisionExplanation | null
  // compact: só o ícone, com a explicação via tooltip nativo (title) — pra
  // espaços apertados como células de tabela e badges.
  compact?: boolean
  className?: string
}

export function PrecisionHint({ explanation, compact = false, className }: Props) {
  if (!explanation) return null

  const Icon = explanation.kind === 'unavailable' ? HelpCircle : AlertTriangle
  const toneClass = explanation.kind === 'unavailable' ? 'text-fg-3' : 'text-danger'

  if (compact) {
    // title vive no wrapper porque Lucide não expõe `title` em LucideProps.
    return (
      <span title={explanation.message} className={cn('inline-flex shrink-0 cursor-help', className)}>
        <Icon className={cn('h-3.5 w-3.5', toneClass)} aria-label={explanation.message} />
      </span>
    )
  }

  return (
    <div className={cn('flex items-start gap-1.5 text-xs mt-1', toneClass, className)} title={explanation.message}>
      <Icon className="h-3.5 w-3.5 shrink-0 mt-0.5" />
      <span>{explanation.message}</span>
    </div>
  )
}
